import { QueryClient } from "@tanstack/react-query";
import { isApiError } from "@empite/api-client";
/**
 * createQueryClient is the one place the portals decide how the platform is
 * retried.
 *
 * The rule that matters: a 4xx is never retried. The platform's failures are
 * decisions — not signed in, not yours, not enough credit — and repeating the
 * request three times changes none of them while tripling the load a
 * rate-limited client is already generating. Only a transport failure or a
 * 5xx is worth a second attempt.
 */
export function createQueryClient() {
    return new QueryClient({
        defaultOptions: {
            queries: {
                retry: (failureCount, error) => {
                    if (isApiError(error) && error.status < 500) {
                        return false;
                    }
                    return failureCount < 2;
                },
                staleTime: 15_000,
                refetchOnWindowFocus: false,
            },
            mutations: {
                // A mutation moves money or ends a session. Retrying one
                // automatically is how a single top-up becomes two charges, so it is
                // always the caller's explicit decision.
                retry: false,
            },
        },
    });
}
//# sourceMappingURL=query.js.map